import { DocumentNode, gql } from '@apollo/client';

export function listTreasuriesOnChainQuery(chainId: number): DocumentNode {
  return gql`
  query listTreasuries {
    listTreasuries (filter: {chainId: {eq: ${chainId}}, isLegacy: { eq: false }}) {
      items {
        address
        base
        displayName
        circulation
        collateral {
          balance
          name
        }
        collateralPositionsAPY
        collateralPositionsUSD
        collateralPositions {
          usdValue
          assets {
            balance
            name
          }
          percentOwnership
          name
          LP
        }
        withdrawFee
        mintFee
        mintingRatio
        usdc
        chainId
        tradeUrl
        oneTokenVersion
        treasuryBacked
        stimulusUSD
        stimulusPositionsAPY
        stimulusPositionsUSD
        stimulusPositions {
          usdValue
          assets {
            balance
            name
          }
          percentOwnership
          name
          LP
        }
        stimulus {
          balance
          name
        }
        strategy
        reserveRatio
        name
        collateralUSD
      }
    }
  }
`;
}
